/**
 * v260.118 — Derive sensible Project Conditions defaults from the
 * customer's maturity band. Emerging customers need a longer runway
 * (governance friction, more readiness work) so duration + hypercare
 * stretch out; Optimized customers can sprint.
 *
 * Returns `null` when no band is available so callers can no-op cleanly.
 *
 * Kept in its own tiny module so it can be unit-tested without dragging
 * the whole EstimatorNewPage import graph (router, axios, …) into Jest.
 */
export function suggestConditionsFromBand(band) {
  if (!band) return null;
  switch (band) {
    case 'Emerging':
      return { goal_duration_weeks: 24, hypercare_weeks: 8 };
    case 'Developing':
      return { goal_duration_weeks: 20, hypercare_weeks: 6 };
    case 'Managed':
      return { goal_duration_weeks: 16, hypercare_weeks: 4 };
    case 'Optimized':
      return { goal_duration_weeks: 12, hypercare_weeks: 2 };
    default:
      return null;
  }
}

// v260.119's `suggestMaturityPremiumFromBand` was removed in v260.120 —
// the maturity premium concept was integrated directly into the existing
// Project Factors readiness sliders (4 sliders × per-pillar score → slider
// multiplier). See routes/maturity_assessment.py::apply_readiness_baseline.
